import { render, staticRenderFns } from "./AccreditationTag.vue?vue&type=template&id=4965a1b0&scoped=true"
import script from "./AccreditationTag.vue?vue&type=script&lang=js"
export * from "./AccreditationTag.vue?vue&type=script&lang=js"
import style0 from "./AccreditationTag.vue?vue&type=style&index=0&id=4965a1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965a1b0",
  null
  
)

export default component.exports